import { createAction, props } from '@ngrx/store';

export const onProfileJobSelectCardProfileId = createAction(
  '[Profile Job Card] on select card profile id',
  props<{ profileId: number }>()
);
